export default {
  label: {
    normal: {
      textStyle: {
        color: '#ffffff'
      }
    },
    emphasis: {
      textStyle: {
        color: '#ffffff'
      }
    }
  }
};